import { render, staticRenderFns } from "./SyncDrafts.vue?vue&type=template&id=1acfa986&scoped=true"
import script from "./SyncDrafts.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncDrafts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SyncDrafts.vue?vue&type=style&index=0&id=1acfa986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acfa986",
  null
  
)

export default component.exports